module.exports = {"sortable":{"labels":{"sort":"Activater le trie","done":"Terminer"}}}


//////////////////
// WEBPACK FOOTER
// ./components/Custom/Sortable/sortable-fr.json
// module id = HPEP
// module chunks = 18